var map = {
	"./M98/banner_en.png": "c632",
	"./M98/banner_id.png": "87a6",
	"./M98/banner_th.png": "95a1",
	"./M98/banner_usdt.png": "2fce",
	"./M98/banner_yn.png": "e90a",
	"./M98/banner_zh.png": "ac54",
	"./bg_bot.png": "c391",
	"./bg_mid.png": "9b64",
	"./bg_top.png": "87b1",
	"./bg_white.png": "c3c5",
	"./bonus_pc_en.png": "510d",
	"./bonus_pc_id.png": "8c65",
	"./bonus_pc_th.png": "4e68",
	"./bonus_pc_yn.png": "58a4",
	"./bonus_pc_zh.png": "7063",
	"./bonus_phone_en.png": "86bf",
	"./bonus_phone_id.png": "7c82",
	"./bonus_phone_th.png": "140b",
	"./bonus_phone_usdt.png": "6ca1e",
	"./bonus_phone_yn.png": "8d15",
	"./bonus_phone_zh.png": "7754",
	"./btn_query.png": "9192",
	"./btn_tab.png": "d46b",
	"./btn_tab_active.png": "d609",
	"./btn_tabfirst.png": "a81e",
	"./btn_tabfirst_active.png": "5eed",
	"./btn_tablast.png": "8ad6",
	"./btn_tablast_active.png": "e5ec",
	"./flag_Indonesia.png": "477d",
	"./flag_Vietnamese.png": "0358",
	"./flag_america.jpg": "7bed",
	"./flag_china.png": "0beb",
	"./flag_thai.png": "c014",
	"./game_pc_en.png": "c3ea",
	"./game_pc_id.png": "fdc4",
	"./game_pc_th.png": "2114",
	"./game_pc_yn.png": "e8b2",
	"./game_pc_zh.png": "4f75",
	"./game_phone_en.png": "c534",
	"./game_phone_id.png": "9976",
	"./game_phone_th.png": "5695",
	"./game_phone_usdt.png": "a1b1",
	"./game_phone_yn.png": "f0ac",
	"./game_phone_zh.png": "45e9",
	"./img_concern.png": "fb93",
	"./img_prize.png": "a47e",
	"./img_prize1.png": "bd06",
	"./img_red.png": "52e0",
	"./line.png": "fe82",
	"./logo.png": "9d64",
	"./new_btn_tabfirst.png": "bc37",
	"./new_btn_tabfirst_active.png": "6d9d",
	"./new_btn_tablast.png": "724a",
	"./new_btn_tablast_active.png": "465c",
	"./vipprivileges_th.png": "04e3",
	"./vipprivileges_zh.png": "6b21",
	"./whatsapp.png": "d253",
	"./zalo.png": "61e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";